import { gql } from "graphql-request";

/**
 * Fragment for retrieving all relevant image metadata from the UploadFile type.
 * Used across multiple GraphQL queries for consistent image structure.
 */
export const IMAGE_FRAGMENT = gql`
  fragment ImageUrlProperties on UploadFile {
    name
    alternativeText
    caption
    width
    height
    formats
    ext
    mime
    size
    cloudflare_url
    url
    previewUrl
  }
`;

/**
 * Fragment for fetching SEO metadata for generic pages.
 * Includes title, description, keywords, and associated image details.
 */
export const SEO_FRAGMENT = gql`
  ${IMAGE_FRAGMENT}
  fragment SEOProperties on ComponentHomeSeo {
    id
    page_title
    page_description
    page_keywords
    page_represent_image {
      ...ImageUrlProperties
    }
    no_index
  }
`;

// Reusable plain string version of the SEO fragment for queries not using gql template.
export const SEO_PROPERTY_FRAGMENT = `
  fragment SEOProperties on ComponentHomeSeo {
    id
    page_title
    page_description
    page_keywords
    page_represent_image {
      ...ImageUrlProperties
    }
    robots
    no_index
  }
`;

/**
 * Fragment for retrieving SEO properties specific to Japan-related pages.
 * Structured similarly to SEO_FRAGMENT but based on the ComponentJapanSeo type.
 */
export const SEO_JAPAN_FRAGMENT = gql`
  ${IMAGE_FRAGMENT}
  fragment SEOJapanProperties on ComponentJapanSeo {
    id
    page_title
    page_description
    page_keywords
    page_represent_image {
      ...ImageUrlProperties
    }
    robots
    no_index
  }
`;

/**
 * Fragment for retrieving CTA (Call-to-Action) properties from ComponentMoleculesCta type.
 * Includes all styling, link, and image properties for consistent CTA structure across queries.
 */
export const CTA_FRAGMENT = gql`
  ${IMAGE_FRAGMENT}
  fragment CtaProperties on ComponentMoleculesCta {
    id
    label
    margin
    padding
    borderRadius
    fontColor
    bgColor
    link
    fontSize
    width
    pdf {
      ...ImageUrlProperties
    }
    image {
      ...ImageUrlProperties
    }
    secondaryLabel
  }
`;
